import PropTypes from 'prop-types';

import MultiColumnLayout from '../MultiColumnLayout';
import MaxShowLayout from '../MaxShowLayout';

export const FeatureCards = ({ data = null, containerClass = '' }) => {
  if (
    data.component === 'feature-block' ||
    data.component === 'pavilion-cleanliness'
  ) {
    return (
      <MultiColumnLayout
        data={data}
        componentType="feature-card"
        className={data.component}
        containerClass={containerClass}
      />
    );
  }
  return <MaxShowLayout data={data} componentType="feature-card" />;
};

FeatureCards.propTypes = {
  data: PropTypes.shape(),
  containerClass: PropTypes.string,
};
